import {defineStore} from "pinia";
export const useApplicationStore = defineStore({
    id: 'application',
    state: () => ({
        // initialize state from local storage to enable user to stay logged in
    }),
})